import { render } from "./RegisterGroup.vue?vue&type=template&id=1370a132&scoped=true"
import script from "./RegisterGroup.js?vue&type=script&lang=js"
export * from "./RegisterGroup.js?vue&type=script&lang=js"

import "./RegisterGroup.scss?vue&type=style&index=0&id=1370a132&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1370a132"]])

export default __exports__